import Logger from "../../../core/internal/logger"
import { InAppMessageBridgeInstaller } from "../../iam/ui/html/InAppMessageBridgeInstaller"
import { NoopInAppMessageBridge } from "../../iam/ui/html/NoopInAppMessageBridge"
import DefaultBrowserPropertyProvider from "../../property/BrowserPropertyProvider"
import { BrowserHackleClient } from "../../index.browser"
import { AppWebViewInAppMessageBridge } from "./AppWebViewInAppMessageBridge"
import { isHackleWebApp } from "../HackleWebAppClient"
import { createInvocationProcessor } from "../invocator/createInvocationProcessor"

const log = Logger.log

interface InstallAppWebViewInAppMessageBridgeParams {
  targetWindow: Window
  createClientBySdkKey: (sdkKey: string) => BrowserHackleClient
}

/**
 * @param targetWindow - 실행되는 런타임의 window 객체
 * @param createClientBySdkKey - sdkKey를 받아서 {@link BrowserHackleClient}를 생성하는 함수, Hackle App SDK Key가 사용됩니다.
 * @description targetWindow에 {@link AppWebViewInAppMessageBridge}를 설치합니다.
 */
export function installAppWebViewInAppMessageBridge({
  targetWindow,
  createClientBySdkKey
}: InstallAppWebViewInAppMessageBridgeParams): void {
  if (InAppMessageBridgeInstaller.isBridgeInstalled(targetWindow)) {
    log.debug("AppWebViewInAppMessageBridge is already installed")
    return
  }

  const bridge = (() => {
    try {
      if (!isHackleWebApp(targetWindow)) {
        throw new Error("AppWebViewInAppMessageBridge is only supported in WebApp integrated environment")
      }

      const hackleApp = targetWindow._hackleApp
      const browserPropertyProvider = new DefaultBrowserPropertyProvider()
      const invocationProcessor = createInvocationProcessor(hackleApp)
      const hackleClient = createClientBySdkKey(hackleApp.getAppSdkKey())

      const viewId = hackleApp.getInAppMessageViewId?.()
      if (!viewId) throw new Error("ViewId is not found")

      return new AppWebViewInAppMessageBridge(viewId, hackleClient, invocationProcessor, browserPropertyProvider)
    } catch (err) {
      log.error(`Failed to install AppWebViewInAppMessageBridge: ${err}`)
      return new NoopInAppMessageBridge()
    }
  })()

  InAppMessageBridgeInstaller.install(targetWindow, bridge)
}
